import {
    keyIsLoggedIn,
    keyFetchUserLogin,
    keyUserToken
} from '../constants';

const initialState = {  
    isLoggedIn: false,
    loggedInUser: {},
    token:"",
    isLoading: false,
};

export default (state, action) => {
    state = state || initialState;

    if (action.type === keyIsLoggedIn) {
        return {
            ...state,
            isLoggedIn: action.isLoggedIn,
        };
    }

    else if (action.type === keyFetchUserLogin) {
        return {
            ...state,
            loggedInUser: action.loggedInUser,
        };
    }

    else if (action.type === keyUserToken) {
        return {
            ...state,
            token: action.token,
        };
    }

    return state;
};
